import {
  GET_SALES_EVENT_TYPES_REQUESTED,
  GET_SALES_EVENT_TYPES_SUCCEEDED,
  GET_SALES_EVENT_TYPES_FAILED,
} from './constants'
import api from '../../utils/api'

export const getSalesEventTypesRequested = () => ({
  type: GET_SALES_EVENT_TYPES_REQUESTED
})

export const getSalesEventTypesSucceeded = (payload) => ({
  type: GET_SALES_EVENT_TYPES_SUCCEEDED,
  payload
})

export const getSalesEventTypesFailed = () => ({
  type: GET_SALES_EVENT_TYPES_FAILED
})

export const loadSalesEventTypes = () => dispatch => {
  dispatch(getSalesEventTypesRequested())

  return api
    .fetchSalesEventTypes()
    .then(response => dispatch(getSalesEventTypesSucceeded(response.data)))
    .catch(() => dispatch(getSalesEventTypesFailed()))
}
